import { INDUSTRY_DISPLAY_MAP, getDisplayName } from '../constants/display-mappings';
import { canonicalIndustryList } from '../constants/industry';

const MAX_STARTUP_INDUSTRY_LABELS = 2;

/** Up to 2 industry values: `industries[]` when set, otherwise primary `industry`. */
export function startupIndustryValues(profile: {
  industry?: string | null;
  industries?: string[] | null;
}): string[] {
  const fromArray = Array.isArray(profile.industries)
    ? profile.industries.filter((v): v is string => typeof v === 'string' && v.trim() !== '')
    : [];
  const selected =
    fromArray.length > 0 ? fromArray : profile.industry ? [String(profile.industry)] : [];
  return canonicalIndustryList(selected).slice(0, MAX_STARTUP_INDUSTRY_LABELS);
}

/** Display labels for the profile card / hover tooltip (one per line). */
export function startupIndustryLabels(profile: {
  industry?: string | null;
  industries?: string[] | null;
}): string[] {
  return startupIndustryValues(profile).map(value =>
    getDisplayName(INDUSTRY_DISPLAY_MAP, value as keyof typeof INDUSTRY_DISPLAY_MAP)
  );
}
